/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./Web192054.css";

function Web192054(props) {
  const { x40387946030_Aa1Ab05241_3K, title, group138, path128 } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-54 screen">
        <div className="overlap-group1-8">
          <img className="x40387946030_aa1ab05241_3k-1" src={x40387946030_Aa1Ab05241_3K} />
          <div className="rectangle-2-17 border-1px-dove-gray"></div>
          <h1 className="title lato-bold-black-140px">{title}</h1>
          <div className="overlap-group-18">
            <div className="group-141-3">
              <div className="group-140-3">
                <div className="group-139-3">
                  <img className="group-138-3" src={group138} />
                </div>
              </div>
            </div>
            <img className="path-128-3" src={path128} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Web192054;
